import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { StaticImage } from 'gatsby-plugin-image';
import { VscTriangleLeft, VscTriangleRight } from 'react-icons/vsc';

const StickyBarWrapper = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  width: 100%;
  height: 40px;
  background-color: var(--custom-green);
  transform: translateY(-40px);
  transition: all 0.25s ease-out;
  &.viewable {
    transform: translateY(0px);
  }
`;

const StickyBarContent = styled.div`
  width: calc(100% - 40px);
  max-width: 200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 4fr 1fr;
  select {
    font-family: var(--block-font);
    line-height: 40px;
    color: white;
    background-color: var(--custom-green);
    border: none;
    cursor: pointer;
    border-radius: 0px;
    height: 40px;
  }
`;

const StickyBar = ({
  stickyView, currentHole, setCurrentHole,
}) => {
  const updateHole = (e) => {
    const holeNum = e.target.value;
    setCurrentHole(parseInt(holeNum, 10));
  };

  return (
    <StickyBarWrapper
      className={stickyView ? 'viewable' : null}
    >
      <StickyBarContent>
        <select value={currentHole.toString()} onChange={updateHole}>
          <option value="1">Hole 1</option>
          <option value="2">Hole 2</option>
          <option value="3">Hole 3</option>
          <option value="4">Hole 4</option>
          <option value="5">Hole 5</option>
          <option value="6">Hole 6</option>
          <option value="7">Hole 7</option>
          <option value="8">Hole 8</option>
          <option value="9">Hole 9</option>
          <option value="10">Hole 10</option>
          <option value="11">Hole 11</option>
          <option value="12">Hole 12</option>
          <option value="13">Hole 13</option>
          <option value="14">Hole 14</option>
          <option value="15">Hole 15</option>
          <option value="16">Hole 16</option>
          <option value="17">Hole 17</option>
          <option value="18">Hole 18</option>
        </select>
      </StickyBarContent>
    </StickyBarWrapper>
  );
};

StickyBar.propTypes = {
  currentHole: PropTypes.number.isRequired,
  setCurrentHole: PropTypes.func.isRequired,
  stickyView: PropTypes.bool.isRequired,
};

export default StickyBar;
